import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkitemActivityIndicatorComponent } from './workitem-activity-indicator.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule
    ],
  declarations: [
    WorkitemActivityIndicatorComponent
  ],
  exports: [
    WorkitemActivityIndicatorComponent
  ]
})
export class WorkitemActivityIndicatorModule {}
